import {
  ProfileAccountPath,
  ProfileAliasesPath,
  ProfileDashboardPath,
  ProfileDevicesPath,
  ProfileEditPath,
  ProfileReportsPath,
  ProfileUsageAndAccessReportsPath,
  ProfileVaultsPath
} from '../paths';
import React, { lazy } from 'react';
import { faChartPie, faUser } from '@fortawesome/free-solid-svg-icons';
import { faGrid, faLaptopMobile } from '@fortawesome/pro-regular-svg-icons';

import AuthRoute from '../AuthRoute';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IBreadcrumbRouteProps } from '../types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faDatabase } from '@fortawesome/sharp-solid-svg-icons';
import strings from '../../strings';

const Profile = lazy(() => import('../../pages/Profile'));
const ProfileDashboard = lazy(() => import('../../pages/Profile/Dashboard'));
const ProfileDevices = lazy(() => import('../../pages/Profile/Devices'));
const ProfileVaults = lazy(() => import('../../pages/Profile/Vaults'));
const ProfileEdit = lazy(() => import('../../pages/Profile/Edit'));
const ProfileAlias = lazy(() => import('../../pages/Profile/Aliases'));
const ProfileReports = lazy(() => import('../../pages/Profile/Reports'));
const UsageAndAccess = lazy(
  () => import('../../pages/Profile/Reports/UsageAndAccess')
);

export const childProfileTabs = [
  {
    path: ProfileAccountPath,
    title: strings.navigationUserProfileAccountTitle,
    id: 'profile-account'
  },
  {
    path: ProfileAliasesPath,
    title: strings.navigationUserProfileAliasesTitle,
    id: 'profile-aliases'
  }
];

export const childReportTabs = [
  {
    path: ProfileReportsPath,
    title: strings.navigationUserProfileEncryptsAndDecryptsTitle
  },
  {
    path: ProfileUsageAndAccessReportsPath,
    title: strings.navigationAdminOrganizationsUsegeAndAccessTitle
  }
];

export const ProfileTabs = [
  {
    path: ProfileDashboardPath,
    title: strings.navigationUserProfileDashboardTitle,
    icon: <FontAwesomeIcon icon={faGrid as IconProp} fontSize={18} />
  },
  {
    path: '',
    title: strings.navigationUserProfileTitle,
    child: childProfileTabs,
    icon: <FontAwesomeIcon icon={faUser as IconProp} fontSize={18} />
  },
  {
    path: ProfileDevicesPath,
    title: strings.navigationUserProfileDevicesTitle,
    icon: <FontAwesomeIcon icon={faLaptopMobile as IconProp} fontSize={18} />
  },
  {
    path: ProfileVaultsPath,
    title: strings.navigationUserProfileVaultsTitle,
    icon: <FontAwesomeIcon icon={faDatabase as IconProp} fontSize={18} />
  },
  {
    path: '',
    title: strings.navigationUserProfileReportsTitle,
    child: childReportTabs,
    icon: <FontAwesomeIcon icon={faChartPie as IconProp} fontSize={18} />
  }
];

const userRoutes: IBreadcrumbRouteProps[] = [
  {
    children: () => (
      <AuthRoute>
        <Profile />
      </AuthRoute>
    ),
    exact: true,
    path: ProfileAccountPath,
    tabs: ProfileTabs
  },
  {
    children: () => (
      <AuthRoute>
        <ProfileDashboard />
      </AuthRoute>
    ),
    exact: true,
    path: ProfileDashboardPath,
    tabs: ProfileTabs
  },
  {
    children: () => (
      <AuthRoute>
        <ProfileDevices />
      </AuthRoute>
    ),
    exact: true,
    path: ProfileDevicesPath,
    tabs: ProfileTabs
  },
  {
    children: () => (
      <AuthRoute>
        <ProfileVaults />
      </AuthRoute>
    ),
    exact: true,
    path: ProfileVaultsPath,
    tabs: ProfileTabs
  },
  {
    children: () => (
      <AuthRoute>
        <ProfileEdit />
      </AuthRoute>
    ),
    tabs: ProfileTabs,
    path: ProfileEditPath
  },
  {
    children: () => (
      <AuthRoute>
        <ProfileAlias />
      </AuthRoute>
    ),
    exact: true,
    path: ProfileAliasesPath,
    tabs: ProfileTabs
  },
  {
    children: () => (
      <AuthRoute>
        <ProfileReports />
      </AuthRoute>
    ),
    tabs: ProfileTabs,
    path: ProfileReportsPath
  },
  {
    children: () => (
      <AuthRoute>
        <UsageAndAccess />
      </AuthRoute>
    ),
    tabs: ProfileTabs,
    path: ProfileUsageAndAccessReportsPath
  }
];

export default userRoutes;
